import { useTranslation } from "react-i18next"
import useStore from "../../../store"
import { carpoolEnabled } from "../../../utilities/featureFlags"

const howToVideos = [
  {
    id: 'fx-transport-dealers',
    title: 'FX Transport - Dealers',
    description: 'Learn how to request and manage vehicle transportation through FX Transport as a dealer.',
    embedUrl: 'https://share.synthesia.io/embeds/videos/06c61eea-75f0-4ef1-b640-ba3ad84b6f3b'
  }
]

export default function HowToVideos() {
  const { t } = useTranslation()
  const dealer = useStore((state) => state.dealer)

  // Temporary: the only video today is carpool-specific, so the whole section is
  // gated on carpoolEnabled. Once a non-carpool video is added, switch back to
  // filtering per-video (e.g. a requiresCarpool flag on each entry).
  if (!carpoolEnabled(dealer)) {
    return null
  }

  return (
    <div className="w-full lg:w-2/3 text-left p-2 mb-2 bg-grey-900 rounded">
      <div className="sticky top-0 left-0 bg-grey-900">
        <h3 className="font-header font-semibold text-md text-green">{t("How-To Videos")}</h3>
      </div>
      {howToVideos.map((video) => (
        <div key={video.id} className="w-full p-1 mb-2">
          <p className="text-sm text-grey-100">{t(video.title)}</p>
          <p className="text-sm text-grey-300 mb-2">{t(video.description)}</p>
          <div className="relative w-full aspect-video overflow-hidden rounded">
            <iframe
              src={video.embedUrl}
              loading="lazy"
              title={video.title}
              allowFullScreen
              allow="encrypted-media; fullscreen; microphone;"
              className="absolute inset-0 w-full h-full border-none"
            />
          </div>
        </div>
      ))}
    </div>
  )
}
